import React from 'react';
import { Button } from 'antd';

class LoadingBtn extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  setLoadings = (loading) => {
    this.setState({
      loading: loading,
    });
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { onClick, type, title } = this.props;

    return (
      <>
        <Button
          type={type}
          loading={this.state.loading}
          onClick={() => {
            this.setLoadings(true);
            onClick();
          }}
        >
          {title}
        </Button>
      </>
    );
  }
}

export default LoadingBtn;
